import { CircleDollarSignIcon, HandshakeIcon } from "lucide-react";

import { cn } from "@/web/lib/styling";
import { CardTimer } from "@/web/routes/browse/-components/cards/CardTimer";

const CARD_TYPE_COLORS = {
  roadshow: "bg-white text-withus-dark-blue",
  offering: "bg-white text-withus-dark-blue",
} as const;

export function CardTypeBadge({
  type,
  className,
}: {
  type: "roadshow" | "offering";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-1 rounded-none px-2 py-1.5 text-[11px] font-semibold tracking-widest uppercase",
        CARD_TYPE_COLORS[type],
        className,
      )}
    >
      {type === "offering" ? (
        <CircleDollarSignIcon className="size-3" />
      ) : (
        <HandshakeIcon className="size-3" />
      )}
      <span>{type === "roadshow" ? "Campaign" : "Offering"}</span>
    </div>
  );
}

export function BrowseCardTimer({ endTimestamp }: { endTimestamp: number }) {
  return (
    <CardTimer
      endTimestamp={endTimestamp}
      innerClassName="rounded-none bg-white/10 px-1 py-1.5 text-[11px] font-semibold text-white backdrop-blur-none"
      className="gap-px text-[11px] font-semibold text-white"
      includeSeconds={false}
    />
  );
}

/** TODO: share modal */
export function CardActions({
  campaignId: _campaignId,
  popoverOpen: _popoverOpen,
  setPopoverOpen: _setPopoverOpen,
}: {
  campaignId: string;
  popoverOpen: boolean;
  setPopoverOpen: (open: boolean) => void;
}) {
  return (
    <>
      {/* Share button: stub – will be wired to share modal when available */}
      {/* <CardButton
        variant="ghost"
        className="text-white/90 hover:bg-white/8 hover:text-white"
        aria-label={`Share campaign ${campaignId}`}
      >
        <ShareIcon />
      </CardButton>
      <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
        <PopoverTrigger asChild>
          <CardButton
            variant="ghost"
            disabled
            className="text-white/90 hover:bg-white/8 hover:text-white [&>div:last-child]:bg-transparent"
          >
            <MoreHorizontalIcon />
          </CardButton>
        </PopoverTrigger>
        <PopoverContent className="flex w-fit p-2" align="start">
        </PopoverContent>
      </Popover> */}
    </>
  );
}

const MASKED_PLACEHOLDER = "•••";

export function MetricCell({
  label,
  value,
  secondaryValue,
  stackSecondaryValue,
  className,
  masked,
  maskedLabel,
}: {
  label: string;
  value: string | React.ReactNode;
  secondaryValue?: string;
  /** When true, secondaryValue renders on its own line instead of inline */
  stackSecondaryValue?: boolean;
  className?: string;
  /**
   * When true, the value is replaced with a masked placeholder and the
   * underlying number never reaches the DOM. Used for password-protected
   * cards where the totals are gated behind the `/ttw/<cardId>` access code.
   */
  masked?: boolean;
  /** Screen-reader text for the masked value (e.g. "Password protected"). */
  maskedLabel?: string;
}) {
  return (
    <div className={cn("flex min-w-0 flex-col gap-2 overflow-hidden", className)}>
      <div className="text-[11px] font-semibold tracking-widest text-white/50 uppercase">
        {label}
      </div>
      <div className="withus-strong text-xs">
        {masked ? (
          <span className="inline-flex truncate px-1 blur-[3px] select-none" aria-hidden="true">
            {MASKED_PLACEHOLDER}
          </span>
        ) : stackSecondaryValue ? (
          <>
            <div className="truncate">{value}</div>
            {secondaryValue ? <div className="truncate">{secondaryValue}</div> : null}
          </>
        ) : typeof value === "string" ? (
          <span className="truncate">{`${value}${secondaryValue ? ` ${secondaryValue}` : ""}`}</span>
        ) : (
          <span className="truncate">
            {value}
            {secondaryValue ? ` ${secondaryValue}` : ""}
          </span>
        )}
        {masked && maskedLabel ? <span className="sr-only">{maskedLabel}</span> : null}
      </div>
    </div>
  );
}
